/**
 * TEAMCO advertising attribution tracking.
 * Captures UTM and click-identifier params from the URL into localStorage.
 */
(function ($) {
    'use strict';

    var STORAGE_KEY = 'adv_data';
    var TTL_MS = 60 * 60 * 1000; // 1 hour

    var TRACKING_PARAMS = [
        'utm_source',
        'utm_medium',
        'utm_campaign',
        'utm_id',
        'utm_content',
        'utm_term',
        'utm_device',
        'utm_network',
        'utm_placement',
        'utm_target',
        'utm_adset_id',
        'utm_ad_id',
        'gclid',
        'gbraid',
        'wbraid',
        'fbclid'
    ];

    function getUrlParams() {
        var params = {};
        var search = window.location.search;

        if (!search || search.length < 2) {
            return params;
        }

        search.substring(1).split('&').forEach(function (pair) {
            if (!pair) {
                return;
            }

            var parts = pair.split('=');
            var key = decodeURIComponent((parts[0] || '').replace(/\+/g, ' '));
            var value = parts.length > 1
                ? decodeURIComponent((parts[1] || '').replace(/\+/g, ' '))
                : '';

            if (key) {
                params[key] = value;
            }
        });

        return params;
    }

    function hasTrackingParams(urlParams) {
        return TRACKING_PARAMS.some(function (key) {
            return Object.prototype.hasOwnProperty.call(urlParams, key);
        });
    }

    function buildSourceSnapshot(urlParams) {
        var snapshot = {};

        TRACKING_PARAMS.forEach(function (key) {
            if (Object.prototype.hasOwnProperty.call(urlParams, key)) {
                snapshot[key] = urlParams[key] || '';
            }
        });

        snapshot.landing_page_url = window.location.href;
        snapshot.referrer_url = document.referrer || '';
        snapshot.attribution_captured_at = new Date().toISOString();

        return snapshot;
    }

    function clearStoredData() {
        try {
            localStorage.removeItem(STORAGE_KEY);
        } catch (error) {
            // localStorage may be unavailable in private mode or blocked storage.
        }
    }

    function isExpired(data) {
        if (!data || !data.expires_at) {
            return false;
        }

        return Date.now() > new Date(data.expires_at).getTime();
    }

    function loadStoredData() {
        try {
            var raw = localStorage.getItem(STORAGE_KEY);

            if (!raw) {
                return null;
            }

            var data = JSON.parse(raw);

            if (isExpired(data)) {
                clearStoredData();
                return null;
            }

            return data;
        } catch (error) {
            clearStoredData();
            return null;
        }
    }

    function saveStoredData(data) {
        try {
            data.expires_at = new Date(Date.now() + TTL_MS).toISOString();
            localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
        } catch (error) {
            // localStorage may be unavailable in private mode or blocked storage.
        }
    }

    function getPayloadForSubmit(data) {
        if (!data) {
            return null;
        }

        var payload = {
            first_source: data.first_source || null,
            most_recent_source: data.most_recent_source || null
        };

        if (!payload.first_source && !payload.most_recent_source) {
            return null;
        }

        return payload;
    }

    function capture() {
        var urlParams = getUrlParams();
        var stored = loadStoredData() || {};

        if (!hasTrackingParams(urlParams)) {
            return;
        }

        var snapshot = buildSourceSnapshot(urlParams);

        if (!stored.first_source) {
            stored.first_source = snapshot;
        }

        stored.most_recent_source = snapshot;
        saveStoredData(stored);
    }

    function getForSubmit() {
        var stored = loadStoredData();
        var payload = getPayloadForSubmit(stored);

        return payload ? JSON.stringify(payload) : '';
    }

    window.TeamcoAdvData = {
        capture: capture,
        getForSubmit: getForSubmit,
        get: loadStoredData,
        clear: clearStoredData
    };

    $(document).ready(function () {
        loadStoredData();
        capture();
    });
})(jQuery);
